import React from "react";
import { Link } from "react-router-dom";
import BoxedTitle from "@/components/BoxedTitle";

export default function Footer() {
  return (
    <footer
      className="vbb-border-t mt-32 bg-[#fafafa]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-1">
              <span className="font-display text-[15px] tracking-tight uppercase pl-[0.35em]">
                <BoxedTitle size="sm">V</BoxedTitle>
                ery Big Box
              </span>
              <span className="font-mono-tiny text-[#6b6b6b] ml-2">LLC</span>
            </div>
            <p className="mt-8 font-display text-3xl sm:text-4xl leading-[1.05] max-w-xl tracking-tight pl-[0.35em]">
              <BoxedTitle size="md">Thinking</BoxedTitle> outside the box,
              <br />
              from inside one.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="vbb-overline mb-5">Sitemap</div>
            <ul className="space-y-2 text-[15px]">
              <li>
                <Link
                  to="/about"
                  className="vbb-link"
                  data-testid="footer-about-link"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="vbb-link"
                  data-testid="footer-portfolio-link"
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="vbb-link"
                  data-testid="footer-services-link"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/history"
                  className="vbb-link"
                  data-testid="footer-history-link"
                >
                  History
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="vbb-link"
                  data-testid="footer-contact-link"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="vbb-overline mb-5">Elsewhere</div>
            <ul className="space-y-2 text-[15px]">
              <li>
                <a
                  href="https://allamericandog.club"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vbb-link"
                  data-testid="footer-aadc-link"
                >
                  allamericandog.club &#8599;
                </a>
              </li>
              <li>
                <a
                  href="https://emergent.sh"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vbb-link"
                  data-testid="footer-emergent-link"
                >
                  emergent.sh &#8599;
                </a>
              </li>
              <li>
                <a
                  href="https://linkedin.com/in/garyebickford"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="vbb-link"
                  data-testid="footer-linkedin-link"
                >
                  LinkedIn &#8599;
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="vbb-border-t mt-20 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono-tiny text-[#6b6b6b]">
            © {new Date().getFullYear()} Very Big Box LLC. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <span className="font-mono-tiny text-[#9a9a9a]">
              VBB-001 / Build {new Date().getFullYear()}
            </span>
            <Link
              to="/login"
              data-testid="footer-login-link"
              className="text-[11px] tracking-[0.18em] uppercase text-[#9a9a9a] hover:text-[#0a0a0a]"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
